import angular from 'angular'
import ngRedux from 'ng-redux'
import { selectPaymentHeading } from '../../state/slices/currentSale/currentSaleSlice'
import { RootState } from '../../state/store'

/**
 * Sale payment heading
 *
 * @module webregister.directives.wrSalePaymentHeading
 */
angular
  .module('webregister.directives')
  .directive('wrSalePaymentHeading', function () {
    return {
      restrict: 'E',
      template: '{{::salePaymentHeadingCtrl.heading}}',
      controllerAs: 'salePaymentHeadingCtrl',
      bindToController: true,

      /**
       * =======================================
       * SALE PAYMENT HEADING CONTROLLER
       * =======================================
       */
      controller(
        this: {
          heading: string
          _determineHeading: () => string
        },
        $scope: angular.IScope,
        $ngRedux: ngRedux.INgRedux
      ) {
        this.heading = selectPaymentHeading($ngRedux.getState())
        const unsubscribe = $ngRedux.connect((state: RootState) => {
          this.heading = selectPaymentHeading(state)
          return state
        })(this)

        $scope.$on('$destroy', unsubscribe)
      },
    }
  })
